
import ReactHtmlParser from 'react-html-parser';

const processHtml = (html) => {
    return ReactHtmlParser(html);
};

export default processHtml;
